module.exports = __webpack_public_path__ + "NoeDisplay-Bold.84612e590b6adb016a6f.woff";


//////////////////
// WEBPACK FOOTER
// /opt/buildhome/repo/src/assets/fonts/NoeDisplay-Bold/NoeDisplay-Bold.woff
// module id = ../../../../../src/assets/fonts/NoeDisplay-Bold/NoeDisplay-Bold.woff
// module chunks = styles